import * as _ from 'lodash'

const ASCO_SOURCE = {
	sources: [/^asco:/],
	label: 'ASCO',
	abbrv: 'ASCO'
}
const ASH_SOURCE = {
	sources: ['ash'],
	abbrv: 'ASH'
}
const CORD19_SOURCE = {
	sources: ['CORD19'],
	abbrv: 'CORD'
}
export const NCTID = /^NCT\s?\d{1,8}$/i
export const CTG_SOURCE = {
	sources: ['ClinicalTrials.gov', 'clinicaltrials'],
	label: 'CTG',
	field: 'sourceReferenceId',	// ClinicalTrials.gov docs store id in SourceReferenceId
	base: 'https://clinicaltrials.gov/ct2/show/',
	detect: [
		/^ClinicalTrials.gov\/(NCT\d{8})$/i,
		/^https:\/\/clinicaltrials\.gov\/ct2\/show\/study\/(NCT\d{8})$/i
	]
}
const MEDLINE_SOURCE = {
	sources: ['MEDLINE', 'medline'],
	label: 'PubMed',
	abbrv: 'PMD',
	field: 'medlineId', // Medline docs store id in MedlineID
	base: 'https://www.ncbi.nlm.nih.gov/pubmed/'
}
const DOI_SOURCE = {
	sources: ['DOI'],
	base: 'https://dx.doi.org/'
}
const MEDRXIV_SOURCE = {
	sources: [/medrxiv/i],
	label: 'MedRx',
	abbrv: 'MRX',
	field: 'sourceReferenceId',
	base: ''
}
const CONGRESS_SOURCE = {
	sources: [/doc-congress:/],
	abbrv: 'Cong'
}
const WHO_SOURCE = {
	sources: ['who-ictrp'],
	abbrv: 'WHO'
}
const MANUAL_SOURCE = {
	sources: ['Manual Entry', 'Embase', 'ClinicalTrials Extracted'],
	abbrv: 'EXT'
}
export const EU_SOURCE = {
	sources: ['EU Clinical Trials'],
	label: 'EU-CT',
	abbrv: 'EU',
	field: 'sourceReferenceId',
	base: 'https://www.clinicaltrialsregister.eu/ctr-search/search?query='
}

const SOURCES = [CTG_SOURCE, MEDLINE_SOURCE, DOI_SOURCE, ASCO_SOURCE, ASH_SOURCE, CORD19_SOURCE, MEDRXIV_SOURCE, CONGRESS_SOURCE, WHO_SOURCE, MANUAL_SOURCE, EU_SOURCE]

export function lookupSource(databaseType, requireBase = true) {
	return SOURCES.find(s => ('base' in s || !requireBase) && s.sources.some(e =>
		e instanceof RegExp ? e.test(databaseType) : databaseType == e)
	)
}

const EXT_ID_SOURCE = {
	CTGId: 'ClinicalTrials.gov',
	medlineId: 'MEDLINE',
	DOI: 'DOI'
}

/* additional fields to inspect and infer source url */
const EXT_FIELDS = ['secondarySourceID']

export default function studyUrls(study, user?) {
	if (!study) return []
	const primarySource = study.source
	let urls = []
	let source
	if (primarySource && (source = lookupSource(primarySource))) {
		urls.push({
			srcdef: source,
			source: source.label || primarySource,
			url: source.base + study[source.field]
		})
	}
	for (const extId in EXT_ID_SOURCE) {
		if (study[extId]) {
			const source = lookupSource(EXT_ID_SOURCE[extId])
			urls.push({
				srcdef: source,
				source: source.label || EXT_ID_SOURCE[extId],
				url: source.base + study[extId]
			})
		}
	}
	for (const field of EXT_FIELDS) {
		const val = study[field]
		if (!val) continue
		for (const source of SOURCES) {
			for (const re of source.detect || [])  {
				const match = val.match(re)
				if (match?.[1]) {
					urls.push({
						srcdef: source,
						source: source.label || source.sources[0],
						url: source.base + match[1]
					})
				}
			}
		}
	}
	for (const relation of study.relations || []) {
		const src = lookupSource(relation.source)
		// only consider relations for non-primary sources, that are cited in the abstract
		if (relation.source != primarySource && relation.cited && src) {
			urls.push({
				srcdef: src,
				source: src.label || src.sources[0],
				url: src.base + relation.uri,
				cited: relation.cited
			})
		}
	}
	if (study.fullTextUrl &&
			/* EV-490 hack to retrofix bad data */
			DOI_SOURCE.base + 'undefined' != study.fullTextUrl) {
		urls.push({
			source: 'Full Text',
			url: study.fullTextUrl
		})
	}
	if (study.articleId && user?.Apps?.includes('DOC Search')) {
		urls.push({
			source: 'Doc Search',
			url: `https://search.doctorevidence.com/details/${study.articleId}`
		})
	}
	return _.uniqBy(urls, entry => entry.url.replace(/^https?/i, ''))
}